import React, { useEffect, useState, useRef } from "react";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFilters } from "../../Services/FilterService";
import { getAssets } from "../../Services/AssetService";
import { no_image } from "../../Images";
import { formatDateString, uuid } from "../../Utils/Utils";
import { setDecrementPage, setDefaultPage, setIncrementPage } from "../../Stores/Action/PaginateAction";

const { $ } = window;

const AssetSearchResultPage = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const { search, asset_type, category } = useSelector((state) => state.app);
  const { page } = useSelector((state) => state.paginate);

  const [filtr, setFilters] = useState({
    filters: [],
  });

  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({
    year: "",
    month: "",
    filter: "",
    years: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    assets: [],
    total_asset: 0,
    current_page: page,
    total_page: 1,
    prev_page: null,
    next_page: null,
    from: 1,
    to: 1,
  });

  const setStates = (data) => {
    setState({ ...state, ...data });
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const onBack = () => {
    navigation(-1);
  };

  const closeDropDown = () => {
    $(".mdropdown").animate(
      {
        height: 0,
        opacity: 0,
      },
      250
    );
  };

  const setDateFormat = (param) => {
    let date = "";
    date = param === undefined ? "" : formatDateString(param);
    return date;
  };

  const onYearClick = () => {
    var height = parseInt($("#mdropdown-year").css("height"));
    if (height > 50) {
      closeDropDown();
    } else {
      $("#mdropdown-year").animate(
        {
          height: 400,
          opacity: 1,
        },
        250
      );
    }
  };

  const onShowMoreClick = (data) => {
    setLoading(true);
    setStates({ current_page: data });
  };

  const incrementPage = () => {
    dispatch(setIncrementPage());
  };

  const decrementPage = () => {
    dispatch(setDecrementPage());
  };

  const onMonthClick = () => {
    var height = parseInt($("#mdropdown-month").css("height"));
    if (height > 50) {
      closeDropDown();
    } else {
      $("#mdropdown-month").animate(
        {
          height: 400,
          opacity: 1,
        },
        150
      );
    }
  };

  const onFilterClick = () => {
    var height = parseInt($("#mdropdown-filter").css("height"));
    if (height > 50) {
      closeDropDown();
    } else {
      const height = parseInt($("#mdropdown-filter > div").css("height")) + 2;
      $("#mdropdown-filter").animate(
        {
          height: height,
          opacity: 1,
        },
        150
      );
    }
  };

  const onResetClick = () => {
    setLoading(true);
    setStates({ year: "", month: "", filter: "" });

    if (state.year === "" && state.month === "" && state.filter === "") {
      setLoading(false);
    }
  };

  const onSelectYear = (year) => async () => {
    setLoading(true);
    setStates({ year });
  };

  const onSelectMonth = (month) => () => {
    setLoading(true);
    setStates({ month });
  };

  const onSelectFilter = (filter) => () => {
    setLoading(true);
    setStates({ filter });
  };

  const onAssetClick = (id) => () => {
    navigation("/asset/detail/" + id);
  };

  useEffect(() => {
    getFilters({ page: 1, perpage: 100, order: `created_on`, direction: `desc`, select: `filter_name`, filter: `is_active:true` }).then((res) => {
      setFilters({ filters: res.data.data });
    });
  }, []);

  const { current_page, year, years, month, months, filter, assets, total_asset, total_page, next_page, prev_page, from, to } = state;

  const { filters } = filtr;

  useEffect(() => {
    const { year, month, filter } = state;
    let filter_params = "";
    let searchs = "";
    let orders = `created_on`;
    let directions = `desc`;
    let perpages = 12;
    filter_params = `is_active:true,status:Publish,access:AclPrivate,storage_class:Standard`;
    filter_params += asset_type != "" ? `,type.type_name:${asset_type}` : "";
    filter_params += category != "" ? `,category.category_name:${category}` : "";
    filter_params += year != "" ? `,asset_year:${year}` : "";
    filter_params += month != "" ? `,asset_month:${month}` : "";
    filter_params += filter != "" ? `,filter.filter_name:${filter}` : "";

    switch (search) {
      case "Favorite images":
        filter_params += `,type.type_name:Images`;
        orders = `most_view`;
        break;
      case "Favorite videos":
        filter_params += `,type.type_name:Video`;
        orders = `most_view`;

        break;
      case "Most download":
        orders = `most_download`;
        break;
      case "Most search":
        orders = `most_view`;
        break;
      case "Recently download":
        orders = `download_on`;
        break;
      case "New Assets":
        orders = `created_on`;
        break;
      default:
        searchs = search;
        break;
    }

    getAssets({
      page: page,
      perpage: perpages,
      order: orders,
      direction: directions,
      search: searchs,
      filter: filter_params,
      select: `title,thumbnail,created_on,asset_month,asset_year`,
    }).then((res) => {
      setLoading(false);
      setStates({
        assets: res.data.data,
        total_asset: res.data.total,
        total_page: res.data.total_page,
        prev_page: res.data.prev_page,
        next_page: res.data.next_page,
        from: res.data.data.length === 0 ? 0 : res.data.from,
        to: res.data.to,
        current_page: res.data.data.length === 0 ? 0 : page, // this value is not from result, but from redux for reset that pagination
      });
    });
  }, [asset_type, search, category, year, month, filter, page]);

  return (
    <div className="container">
      <div className="raw">
        <div className="md-col-12"></div>
      </div>
      <div onClick={onBack} className="button_back">
        <span className="fa fa-chevron-left" style={{ marginRight: 10 }}></span> <span> Back</span>
      </div>

      <div className="title_search">
        Showing result for <strong>{search}</strong>
      </div>
      <div style={{ textAlign: "center", fontSize: 14, fontFamily: "Inter", marginTop: 5 }}>
        Showing{" "}
        <strong>
          {" "}
          {from} - {to} Items
        </strong>{" "}
        / Total <strong> {total_asset} Items</strong>
      </div>

      <div style={{ display: "flex", marginTop: 64, border: "solid 0px", alignItems: "center" }}>
        <div style={{ display: "flex", flex: 2, position: "relative" }}>
          <div className="d-flex justify-content-end flex-grow-1 mobile_flex">
            <div id="myear" className="d-flex justify-content-center align-items-center btn-mdropdown search_filter" onClick={onYearClick}>
              {year || " -- Select Year -- "}
            </div>
            <div id="mdropdown-year" mbutton="myear" className="mdropdown fmyear">
              {years.map((item) => (
                <div key={item} onClick={onSelectYear(item)} className="d-flex mdropdown-item" style={{}}>
                  {item}
                </div>
              ))}
            </div>
            <div id="mmonth" className="btn-mdropdown search_filter" onClick={onMonthClick}>
              {month || " -- Select Month -- "}
            </div>
            <div
              id="mdropdown-month"
              className="mdropdown  fmmonth"
              mbutton="mmonth"
              style={{
                top: 54,
                right: 450,
                width: 200,
              }}
            >
              {months.map((item) => (
                <div key={item} onClick={onSelectMonth(item)} className="d-flex mdropdown-item" style={{}}>
                  {item}
                </div>
              ))}
            </div>
            <div id="mfilter" className="btn-mdropdown search_filter" onClick={onFilterClick}>
              {filter || " -- Select Filter -- "}
            </div>
            <div id="mdropdown-filter" className="mdropdown fmfilter" mbutton="mfilter" style={{ top: 54, right: 235, width: 199 }}>
              <div>
                {filters?.map((item) => (
                  <div key={item._id} onClick={onSelectFilter(item.filter_name)} className="d-flex mdropdown-item" style={{}}>
                    {item.filter_name}
                  </div>
                ))}
              </div>
            </div>
            <div id="mfilter" className="btn-mdropdown search_filter" onClick={onResetClick}>
              Reset
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex" style={{ flexWrap: "wrap", marginTop: 64 }}>
        {loading ? (
          <div className="d-flex mt-5" style={{ justifyContent: "center", alignItems: "center", height: 54, width: "100%" }}>
            <div className="spinner-border" role="status" />
          </div>
        ) : (
          assets.map((item) => (
            <div key={uuid()} className="d-flex item-list" style={{}} onClick={onAssetClick(item._id)}>
              <img
                src={item.thumbnail.preview_url != "" ? process.env.REACT_APP_OBS_URL + item.thumbnail.preview_url : no_image}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                alt=""
              />
              <div className="wrap-card-overlay-5">
                <div style={{ position: "absolute", bottom: 20 }}>
                  <div className="card-text-title-16 card-text-overflow-16">{item.title}</div>
                  <div className="card-text-title-12">{setDateFormat(item.created_on)}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {assets.length > 0 && (
        <div className="d-flex mt-5" style={{ justifyContent: "center", alignItems: "center", height: 54, gap: "20px" }}>
          <button
            className="btn btn-lg btn-primary"
            type="button"
            disabled={prev_page == null}
            onClick={() => {
              onShowMoreClick(prev_page);
              decrementPage();
            }}
          >
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
          <div>
            {current_page} / {total_page}
          </div>
          <button
            className="btn btn-lg btn-primary"
            type="button"
            disabled={next_page == null}
            onClick={() => {
              onShowMoreClick(next_page);
              incrementPage();
            }}
          >
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      )}

      <div style={{ height: 120 }}></div>
    </div>
  );
};

export default AssetSearchResultPage;
